module.exports = __webpack_public_path__ + "img/brands-barilla-quality-manifesto.png?ee3136a81c1295b10b019942dbe40cb7";